import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { StorefrontVm } from 'qp-ui-interface';
import { Observable, from } from 'rxjs';
import { CatalogService } from '../../storefront/catalog.service';

@Injectable()
export class CollectionContainerResolver implements Resolve<StorefrontVm> {
  constructor(private readonly catalogService: CatalogService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<StorefrontVm> {
    return from(this.fetchCollectionContainers(route));
  }

  private async fetchCollectionContainers(
    route: ActivatedRouteSnapshot
  ): Promise<any> {
    try {
      const collectionId = route.params?.id;
      if (!collectionId) {
        throw new Error('Collection ID is required');
      }

      const result = await this.catalogService.getCollectionStorefrontData(
        collectionId
      );

      return {
        containers: result.containers || [],
        totalContainers: result.totalContainers || 0,
        isCollection: true,
      };
    } catch (error) {
      return {
        containers: [],
        totalContainers: 0,
      };
    }
  }
}
